var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveFavouriteMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34,4c-4.0302734,0-7.7832031,2.0888672-10,5.4462891C21.7832031,6.0888672,18.0302734,4,14,4C7.3828125,4,2,9.3828125,2,16 c0,8.34375,4.9658203,14.3808594,9.2929688,18.7070312L21.5859375,45C22.2304688,45.6445312,23.0878906,46,24,46 s1.7695312-0.3554688,2.4140625-1l10.2929688-10.2929688C41.0341797,30.3808594,46,24.34375,46,16C46,9.3828125,40.6171875,4,34,4z  M35.2929688,33.2929688L25,43.5859375c-0.5351562,0.5332031-1.4648438,0.5332031-2,0L12.7070312,33.2929688 C8.6533203,29.2392578,4,23.6103516,4,16C4,10.4863281,8.4863281,6,14,6c3.8701172,0,7.4394531,2.3232422,9.0917969,5.9179688 C23.2548828,12.2724609,23.609375,12.5,24,12.5s0.7451172-0.2275391,0.9082031-0.5820312C26.5605469,8.3232422,30.1298828,6,34,6 c5.5136719,0,10,4.4863281,10,10C44,23.6103516,39.3466797,29.2392578,35.2929688,33.2929688z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFavouriteMedium);
export default __webpack_public_path__ + "static/media/save-favourite--medium.43ce9bd7316e6a7d7983055e7b1cf8d0.svg";
export { ForwardRef as ReactComponent };